import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const InvoicePartyPage = lazy(() => import('@/containers/Views/InvoiceParty/InvoicePartyPage'));
const CreateInvoicePartyPage = lazy(() => import('@/containers/Views/InvoiceParty/CreateInvoicePartyPage'));
const EditInvoicePartyPage = lazy(() => import('@/containers/Views/InvoiceParty/EditInvoicePartyPage'));

const InvoicePartyRouter = (
  <Route path="invoice_parties">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.InvoiceParties} 
          permissions={EBasicActions.Find}
        >
          <InvoicePartyPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="new"
      element={(
        <PrivateRoute 
          pageName={EPage.InvoiceParties} 
          permissions={EBasicActions.Create}
        >
          <CreateInvoicePartyPage />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":invoicePartyId/edit"
      element={(
        <PrivateRoute 
          pageName={EPage.InvoiceParties} 
          permissions={EBasicActions.Edit}
        >
          <EditInvoicePartyPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default InvoicePartyRouter;
